import React, { useState, useContext } from "react";
import "./upcomingmeetings.css";
import { ReactComponent as MySVG } from "../../../../../assets/Svg/Cross_Cancel.svg";
import { ReactComponent as ViewSVG } from "../../../../../assets/Svg/View.svg";
import { ReactComponent as EditSVG } from "../../../../../assets/Svg/Edit.svg";
import { ReactComponent as ShareSVG } from "../../../../../assets/Svg/Download.svg";
import { BsEye } from "react-icons/bs";
import { SlPencil } from "react-icons/sl";
import { AiOutlineDelete } from "react-icons/ai";

import { FiLink } from "react-icons/fi";
import { BiLink } from "react-icons/bi";

import { red } from "@mui/material/colors";
import { AiOutlineRight, AiOutlineClose } from 'react-icons/ai';
import { BsDownload } from 'react-icons/bs'
import { IoPersonCircleOutline } from "react-icons/io5";
import { FaArrowRight, FaLessThanEqual } from "react-icons/fa6";
import { GET, GETBYID, POST, PUT } from "../../../../Common/HttpMethods/HttpMethods";
import { Url } from "../../../../../constants/ApiUrlConstants";
import { useEffect } from "react";
import moment from 'moment';
import person from '../../../../../assets/Images/person.webp'
import { useNavigate } from "react-router-dom";
import { contextData } from "../../../../../context/ContextProvider";
import FailModal from "../../../../Common/Popups/FailModal";
import SuccessModal from "../../../../Common/Popups/SuccessModal";
import CancelReason from "../../../../Common/Popups/CancelReason";
import { FileDownload } from "../../../../Common/IcsDownload/FileDownload";
import Modal from "react-modal";
import { Hidden } from "@mui/material";
import { Cuurent_EMAIL, Cuurent_RBAC_roles, Cuurent_USERNAME, extractMeetingData, firstLineTextFromHtml, getEmailClassification, handleCancel, handleOverflowCheck, stripHtmlTags, useOverflowCheck } from "../../../../CommonCase/CommonFunctions";
import UpcomingMeetingModal from "../../../../CommonCase/UpcomingMeetingModal";

export const handleCancelMeetingClick = (rbac, from, Email, item, setFailMessage, setOpenCancelModal, setIdToCancelMeeting, setCancelMeetingName) => {
  if (rbac?.deleteAccess === "Y" && from[0]?.participantEmail === Email) {
    setFailMessage('Are you sure you want to cancel this meeting?');
    setOpenCancelModal(true);
    setIdToCancelMeeting(item?.mid);
    setCancelMeetingName(item?.meetingSubject);
  }
};

export const downloadIcs = async (id, name) => {
  FileDownload(id, name)
}

export const handleOpenFullView = (setUpcommingMeetOpenView,extractMeetingData,setFullView,item,setLoading) => {
  setUpcommingMeetOpenView(true);
  const data = extractMeetingData(item);

  setFullView((prevState) => ({
    viewMore: false,
    isClicked: false,
    viewMoreAttendees: false,
    typeOfMeeting: item?.typeOfMeeting,
    data
  }));
  setLoading(true);
  setTimeout(() => {
    setLoading(false);
  }, 1100);
};


export const handleCloseFullView = (setFullView) => {
  setFullView((prevState) => ({ viewMore: false, isClicked: false, viewMoreMsg: false, viewMoreAttendees: false, typeOfMeeting: '', data: {} }));
}

export const handleCloseFailModel = (setOpenFailModal) => {
  setOpenFailModal(false);
}

export const handleSessionExpClose = (navigate, setActive) => {
  sessionStorage.clear();
  navigate('/login');
  setActive('tab1');
}

export const handleCloseSuccessModal = (setOpenSuccessModal) => {
  setOpenSuccessModal(false)
}
export const handleCloseCancleModal = (setOpenCancelModal) => {
  setOpenCancelModal(false)
}

export const handleOnRequestCloseUPMModal = (setUpcommingMeetOpenView, setAgendaDivHeight, setMsgDivHeight, setAttendeesDivHeight) => {
  setUpcommingMeetOpenView(false);
  setAgendaDivHeight(false);
  setMsgDivHeight(false);
  setAttendeesDivHeight(false)
}

export const reasonChange = (e, setReason) => {

  setReason(e.target.value)
}


export const handleEdit = (id, navigate) => {
  navigate("/main/meetings/setupmeeting", { state: { meetingId: id, flow: "UpcomingMeetings", upcomingMeetingEdit: true } })
}

export const handleSearch = (inp, dataCopy, setData) => {

  setData(dataCopy?.filter((i) => {
    return i?.meetingSubject?.toLowerCase().includes(inp?.toLowerCase())
  })
  )
}


const UpcomingMeetings = ({ selectedToDate, selectedFromDate, selectedPeriod, searchInp, toggleForCount, setToggleForCount }) => {
  const navigate = useNavigate();
  const { setLoading, setActive } = useContext(contextData);

  // rbac roles  
  let rrbac = Cuurent_RBAC_roles();
  const username = Cuurent_USERNAME();
  let Email = Cuurent_EMAIL();

  const storedRbacRoles = JSON.parse(rrbac);
  const userRole = sessionStorage.getItem("USER")

  const [rbac, setRbac] = useState({});

  useEffect(() => {
    if (userRole !== "USER") {
      const roleWithQMSDashboard = storedRbacRoles?.find(role => role.useCase === "QMS Upcoming Meetings");
      if (roleWithQMSDashboard) {
        setRbac(roleWithQMSDashboard);
      }
    }
  }, []);



  const [data, setData] = useState([]);
  const [dataCopy, setDataCopy] = useState([]);
  const [fullView, setFullView] = useState({
    isClicked: false,
    viewMore: false,
    viewMoreMsg: false,
    viewMoreAttendees: false,
    typeOfMeeting: '',
    data: {
      title: "",
      date: "",
      time: "",
      attendees: [],
      agenda: [],
      startTime: "",
      endTime: "",
      location: "",
      msg: "",
    }
  });

  const abc = ["Akshay Bhagat", "Akshay Bhagat", "Akshay Bhagat", "Akshay Bhagat", "Akshay Bhagat", "Akshay Bhagat", "Akshay Bhagat", "Akshay Bhagat", "Akshay Bhagat", "Akshay Bhagat", "Akshay Bhagat", "Akshay Bhagat", "Akshay Bhagat", "Akshay Bhagat", "Akshay Bhagat", "Akshay Bhagat", "Akshay Bhagat", "Akshay Bhagat", "Akshay Bhagat"]
  // ---------------------------------------------------------------------------Popup Utility----------------------------------------------------------------------
  const [openFailModal, setOpenFailModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [UpcommingMeetOpenView, setUpcommingMeetOpenView] = useState(false)
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [MsgLengthLarger, setMSgLengthLarger] = useState(false)

  const [idToCancelMeeting, setIdToCancelMeeting] = useState();
  const [cancelMeetingName, setCancelMeetingName] = useState("");
  const [sessionExpiredModal, setSessionExpiredModal] = useState(false)




  const [failMessage, setFailMessage] = useState("");

  const [reason, setReason] = useState("")

  const [agendaDivHeight, setAgendaDivHeight] = useState(false);
  const [msgDivHeight, setMsgDivHeight] = useState(false);
  const [attendeesDivHeight, setAttendeesDivHeight] = useState(false)

  useEffect(() => {

  }, [agendaDivHeight])


  useEffect(() => {

  }, [reason])


  function isOverflowing(element) {
    return element?.scrollHeight > element?.clientHeight || element?.scrollWidth > element?.clientWidth;
  }

  useEffect(() => {
    handleOverflowCheck(setAttendeesDivHeight, setAgendaDivHeight, setMsgDivHeight, isOverflowing);
  }, [fullView]);
  // ---------------------------------------------------------------------------Popup End----------------------------------------------------------------------

  useEffect(() => {
    if (selectedToDate) {
      getDashboardData();
    }
  }, [selectedToDate, selectedFromDate])

  useEffect(() => {
    handleSearch(searchInp, dataCopy, setData)
  }, [searchInp])

  

  // const getNumberOfLines = () => {
  //   var divElement = document.getElementById('myDiv');

  //   // Get the line height of the div
  //   var lineHeight = parseInt(window.getComputedStyle(divElement).lineHeight);

  //   // Get the height of the div
  //   var divHeight = divElement.clientHeight;

  //   // Calculate the number of lines
  //   var numberOfLines = divHeight / lineHeight;


  // }


  // ---------------------------------------------------------------------------- Handle Fetch Meeting Data----------------------------------------------------------------



  const getDashboardData = async () => {
    let token = sessionStorage.getItem('TOKEN')

    let allMeetingsBody = {
      fromDate: moment(selectedFromDate).format('YYYY-MM-DD'),
      toDate: moment(selectedToDate).format('YYYY-MM-DD'),
      meetType: "Upcoming"
    }

    try {
      setLoading(true);
      let upcomingMeetingsResp = await POST(Url.getAllTypeOfMeetingWithCount, token, allMeetingsBody);

     
      if (upcomingMeetingsResp.SUCCESS) {
        let a = upcomingMeetingsResp?.DATA?.upcomingMeeting.map((i) => {
          return { ...i, viewMore: false }
        })
        setData(a)
        setDataCopy(a)
        setLoading(false);
      }
      else if (upcomingMeetingsResp?.STATUS == 401) {
        setLoading(false)
        setSessionExpiredModal(true)
        setFailMessage("Session expired")
      }else if (upcomingMeetingsResp?.STATUS == 400) {
        setLoading(false)
        setSessionExpiredModal(true)
        setFailMessage("Session expired")
      }else if (upcomingMeetingsResp?.STATUS == 403) {
        setLoading(false)
        setSessionExpiredModal(true)
        setFailMessage("Session expired")
      }else if (upcomingMeetingsResp?.STATUS == 404) {
        setLoading(false)
        setSessionExpiredModal(true)
        setFailMessage("Session expired")
      }else if (upcomingMeetingsResp?.STATUS == 500) {
        setLoading(false)
        setSessionExpiredModal(true)
        setFailMessage("Session expired")
      }
      else {
        setLoading(false);
        setFailMessage("Failed to fetch meetings.")
        setOpenFailModal(true);
      }

    } catch (error) {

      setLoading(false);
      setFailMessage("Failed to fetch meetings.");
      setOpenFailModal(true);
    }
  }
 
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  // ---------------------------------------------------------------------------- Handle Open Full View----------------------------------------------------------------

  // const handleOpenFullView = (setUpcommingMeetOpenView,extractMeetingData,setFullView,meetingData,setLoading) => {
  //   setUpcommingMeetOpenView(true);
  //   const data = extractMeetingData(meetingData);

  //   setFullView((prevState) => ({
  //     viewMore: false,
  //     isClicked: false,
  //     viewMoreAttendees: false,
  //     typeOfMeeting: meetingData?.typeOfMeeting,
  //     data
  //   }));
  //   setLoading(true);
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 1100);
  // };

 
  useEffect(() => {

  }, [idToCancelMeeting])

  return (
    <>
      {
        data?.length == 0 ? (
          <div className="empty-card">
            No Records to show
          </div>
        ):
            <div className="upcomming-meetings-main-container">
              {

                data?.map((item, index) => {
                  const { to, from, optional } = getEmailClassification(item?.emailDetail);
                  let AttendeesList = '';
                  item?.participantsList?.map((i, index) => {
                    let lastitem = index + 1 == item?.participantsList?.length ? "" : ", ";

                    AttendeesList += i.fullName + lastitem;
                  })

                  return (
                    <div
                      style={{
                        boxShadow: "0px 0px 3px #00000029",

                      }}

                      className={
                        !item.viewMore
                          ? "upcoming-meeting-card full-view-meeting-card"
                          : "upcoming-meeting-card half-view-meeting-card "
                      }
                    >
                      {/* ------------------------tag------------------- */}
                      {
                        item?.meetingStatus == "Rescheduled" &&
                        <div className="tag-wraper">
                          <div className="corner-tag" >{item?.meetingStatus}</div>
                        </div>
                      }

                      <div style={
                        item?.deptartmentTagMaster?.deptTag == "HR"
                          ? {
                            backgroundColor: "rgb(112, 0, 152)",
                          }
                          : item?.deptartmentTagMaster?.deptTag == "IT"
                            ? {
                              backgroundColor: "#4CB87C",
                            }
                            : item?.deptartmentTagMaster?.deptTag == "Governance"
                              ? {
                                backgroundColor: "#057DAA",
                              }
                              : {
                                backgroundColor: "#FF9B00",
                              }
                      } className="card-circle" ></div>
                      <div className="card-main">
                        <div className="card-sub-relative">
                          <div className="meeting-title" style={{ marginBottom: 7, width: "425px", wordBreak: 'break-word', fontWeight: 600, fontSize: "14px", wordSpacing: "4px" }}>{item?.meetingSubject}</div>
                          <div className="sub-card">
                            <div className="meeting-card-heading-text" style={{ fontSize: '13px' }}>
                              <span style={{ fontSize: '13px' }}>Date</span><span>:&nbsp; </span>
                            </div>

                            <div style={{ fontSize: "13px", display: "flex", alignItems: "center", justifyContent: 'space-between', marginLeft: "4%" }}>
                              {item?.parseStartDate} &nbsp;&nbsp;&nbsp;
                              <div className="meeting-card-heading-text" style={{ marginLeft: "76px" }}>
                                <span style={{ fontSize: '13px' }}>Time</span><span> &nbsp;&nbsp; &nbsp;&nbsp;:&nbsp;</span>
                              </div>
                              {item?.startTime} - {item?.endTime === "11:59 PM" ? "12:00 AM" : item?.endTime}
                            </div>
                          </div>
                          <div className="sub-card">
                            <div className="meeting-card-heading-text"> <span>Attendees</span><span>:&nbsp;</span></div>
                            <div style={{ color: "black", fontSize: "13px", marginLeft: "4%" }} className="attendees-text">
                              {
                                // item?.emailDetails[0]?.attendees
                                AttendeesList
                              }
                            </div>
                          </div>
                          <div className="sub-card agenda">
                            <div className="meeting-card-heading-text"><span style={{ fontSize: '13px' }} >Agenda</span><span>:&nbsp;</span></div>
                            <div style={{ fontWeight: 600, fontSize: "13px", marginLeft: "4%" }} className="attendees-text">
                              {!(stripHtmlTags(item?.meetingAgenda).trim().length === 0) ?
                                firstLineTextFromHtml(item?.meetingAgenda) : "Not Available"}


                            </div>
                          </div>

                        </div>

                        <div className="card-right-section">
                          <div className="card-icons-div" id="normal"

                            onClick={() => handleOpenFullView(setUpcommingMeetOpenView,extractMeetingData,setFullView,item,setLoading)}
                          >
                            <BsEye fill="white" size={13} />
                          </div>
                          <div className={rbac?.editAccess == "N" ? "disabled" : "card-icons-div"}
                            id={(from[0]?.participantEmail !== Email || rbac?.editAccess === "N") ? "disabled" : "normal"}
                            onClick={() => { rbac?.editAccess == "Y" && (from[0]?.participantEmail == Email) && handleEdit(item?.mid, navigate) }}

                          >
                            <SlPencil fill="white" size={13} />
                          </div>

                          <div div className={rbac?.deleteAccess == "N" ? "disabled" : "card-icons-div"}

                            id={(from[0]?.participantEmail !== Email || rbac?.deleteAccess === "N") ? "disabled" : "normal"}
                            
                            onClick={() =>
                              handleCancelMeetingClick(
                                rbac,
                                from,
                                Email,
                                item,
                                setFailMessage,
                                setOpenCancelModal,
                                setIdToCancelMeeting,
                                setCancelMeetingName
                              )
                            }
                            >
                            <AiOutlineClose fill="white" size={13} />
                          </div>
                          <div div className="card-icons-div" id="normal" onClick={() => downloadIcs(item?.mid, item?.meetingSubject)}>
                            <BsDownload fill='white' size={13} />
                          </div>
                        </div>

                      </div>
                      <div className="border-div " style={
                        item?.deptartmentTagMaster?.deptTag == "HR"
                          ? {
                            backgroundColor: "rgb(112, 0, 152)",
                          }
                          : item?.deptartmentTagMaster?.deptTag == "IT"
                            ? {
                              backgroundColor: "rgb(76, 184, 124)",
                            }
                            : item?.deptartmentTagMaster?.deptTag == "Governance"
                              ? {
                                backgroundColor: "rgb(5, 125, 170)",
                              }
                              : {
                                backgroundColor: "rgb(255, 155, 0)",
                              }
                      }></div>

                    </div>
                  );
                })
              }


            </div >
      }



      <UpcomingMeetingModal
        isOpen={UpcommingMeetOpenView}
        onRequestClose={() => handleOnRequestCloseUPMModal(setUpcommingMeetOpenView, setAgendaDivHeight, setMsgDivHeight, setAttendeesDivHeight)}
        customStyles={customStyles}
        fullView={fullView}
        setFullView={setFullView}
        setAgendaDivHeight={setAgendaDivHeight}
        setMsgDivHeight={setMsgDivHeight}
        setAttendeesDivHeight={setAttendeesDivHeight}
        attendeesDivHeight={attendeesDivHeight}
        agendaDivHeight={agendaDivHeight}
        msgDivHeight={msgDivHeight}
        stripHtmlTags={stripHtmlTags}
      />

      <FailModal
        openFailModal={openFailModal}
        setOpenFailModal={setOpenFailModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() => handleCloseFailModel(setOpenFailModal)}
        recallFunctiononClose={() => handleCloseFailModel(setOpenFailModal)}
      />



      {/* session expire modal  */}
      <FailModal
        openFailModal={sessionExpiredModal}
        setOpenFailModal={setSessionExpiredModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() => handleSessionExpClose(navigate, setActive)}
        recallFunctiononClose={() => handleSessionExpClose(navigate, setActive)}
      />


      {/* Success Modal */}
      <SuccessModal
        openSuccessModal={openSuccessModal}
        setOpenSuccessModal={setOpenSuccessModal}
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
        recallFunctionOnOk={getDashboardData}
        recallFunctiononClose={() => handleCloseSuccessModal(setOpenSuccessModal)}
      />

      <CancelReason
        openReasonModal={openCancelModal}
        setOpenReasonModal={setOpenCancelModal}
        reasonState={reason}
        setReasonState={setReason}
        reasonChangeFunction={reasonChange}
        meetingName={cancelMeetingName}
        CancelledBy={username}
        recallFunctionOnOk={() => {
          handleCancel({
            idToCancelMeeting,
            reason,
            setLoading,
            setOpenCancelModal,
            setSuccessMessage,
            setOpenSuccessModal,
            setToggleForCount,
            setFailMessage,
            setOpenFailModal,
            setSessionExpiredModal
          })
        }}
        recallFunctiononClose={() => handleCloseCancleModal(setOpenCancelModal)}
        setReason={setReason}
      />
    </>
  );
};

export default UpcomingMeetings;
